import {Navigate} from "react-router-dom";
import {useAuth} from "../../contexts/AuthContext";
import SimpleLoader from "../SimpleLoader";

export function PrivateRoute({children}) {
  const {currentUser, authInitialized} = useAuth();

  if (!authInitialized) {
    return <SimpleLoader />;
  }

  return currentUser ? children : <Navigate to="/login" />;
}
